import order from './order'
import courier from './courier'
import rangeType from './range-type'

export default {
  name: 'Supported',
  path: 'supported',
  meta: {
    label: 'supported',
    auth: 'supported'
  },
  component: {
    name: 'Supported',
    render(c) {
      return c('router-view')
    }
  },
  children: [order, courier, rangeType]
}
